import React, { useState } from 'react';
import ProductItem from '../product/item';
import Carousel from '@components/carousel';
import CompareAtCrates from '../compare-at-modal';

const ProductSlider = ({
  heading = "",
  description,
  productGroupItems = [],
  atcLabel,
  productInfos,
  sliderSettings,
  cardFlags
}) => {
  const [showCompareModal, setShowCompareModal] = useState(false);
  return (
    <>
      <Carousel heading={heading} description={description} settings={{ ...sliderSettings }} className={'product-slider'}>
        {productGroupItems?.map(({ product, hasFeaturedVariants, featuredVariants }, index) => (
          <ProductItem
            key={index}
            index={index}
            product={{
              ...product,
              variants: hasFeaturedVariants && featuredVariants?.length > 0 ? featuredVariants : product?.variants,
            }}
            label={atcLabel}
            productInfos={productInfos}
            cardFlags={cardFlags}
            hasFeaturedVariants={hasFeaturedVariants}
            setShowCompareModal={setShowCompareModal}
          />
        ))}
      </Carousel>
      {showCompareModal && (
        <CompareAtCrates
          showCompareModal={showCompareModal}
          setShowCompareModal={setShowCompareModal}
        />
      )}
    </>
  );
}

export default ProductSlider;